<template>
  <div class="container-dashboard">
    <h3 v-if="mobile" class="page-title col-xs-12">
        Monitorar
      </h3>
    <div class="dashboard column">
      <div
        v-for="item in items"
        :key="item.title"
        class="col-xs-12 col-lg-3 col-sm-4 col-md-3"
      >
        <div :class="[(!managementAccess && item.title == 'setor') || (!alertsAccess && item.title == 'alertas') ? 'dashboard-card-bg-premium' :'dashboard-card-bg'  ,'dashboard-card']" >
          <a>
            <!-- class="dashboard-card col-xs-11 col-sm-5 " -->
            <div class="dashboard-item">
              <div class="topCard align-items-center" lang="de">
                <div class="icons">
                  <water-icon v-if="item.title == 'atuadores'" title="" />
                  <gauge-icon v-else-if="item.title == 'sensores'" title="" />
                  <dir-icon v-else-if="item.title == 'dispositivos'" title="" />
                  <calendar-clock-icon
                    v-else-if="item.title == 'agenda'"
                    title=""
                  />
                  <report-icon
                    v-else-if="item.title == 'relatórios'"
                    title=""
                  />
                  <sector-icon
                    v-else-if="item.title == 'setor' || item.title == 'fazendas'"
                    :class="{'text-info': item.title == 'fazendas'}"
                    title=""
                  />
                  <bell-icon
                    v-else-if="item.title == 'alertas'"
                    :class="{'text-info': item.title == 'fazendas'}"
                    title=""
                  />
                  <chart-icon v-else-if="item.title == 'gráficos'" title="" />
                  <map-marker-icon v-else-if="item.title == 'mapa'" title="" />
                  <weather-icon v-else-if="item.title == 'clima'" title="" />
                  <station-icon v-else-if="item.title == 'estação'" title="" />
                </div>
                <div class="card-info ml-2 ml-lg-3">
                  <div class="title">{{ item.title }}</div>
                  <div class="card-description" style="hyphens: auto; ">{{ item.description }}</div>
                </div>
              </div>

              <!-- <hr /> -->
              <div class="card-details-container col-xs-12">
                <div class="card-details">

                </div>
              </div>

              <footer>
                <div v-if="item.title === 'setor' && !managementAccess">
                  <router-link
                    :to="{ path: '/news'}"
                    class="btn"
                  >
                    🔒
                    <span> Serviço não disponível.</span>
                  </router-link>
                </div>
                

                <div v-else-if="item.title == 'alertas' && !alertsAccess">
                  <router-link
                    :to="{ path: '/news'}"
                    class="btn"
                  >
                    🔒
                    <span> Serviço não disponível.</span>
                  </router-link>
                </div>

                <div v-else>
                  <router-link :to="`/monitoring${item.link}`" class="btn" dsa @click.native="redirectToMap(item.title)">
                    <arrow-right-icon />
                    <span>Ir para {{ item.title }}</span>
                  </router-link>
                </div>
              </footer>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isDevelopment } from "@/helpers/development";

export default {
  name: 'monitoring',
  props: {
    mobile: Boolean,
    managementAccess: Boolean,
    alertsAccess: Boolean,
  },
  created() {
    this.$emit('title-change', 'Monitoramento');
  },
  data () {
    return {
      items: [
        {
          link: '/schedule',
          title: 'agenda',
          description: 'Monitore o progresso das agendas cadastradas',
        },
        {
          link: '/actuators',
          title: 'atuadores',
          description: 'Monitore válvulas, bombas e demais atuadores',
        },
        {
          link: '/sensors',
          title: 'sensores',
          description: 'Monitore sensores e hidrômetros instalados',
        },
        {
          link: '/dirs',
          title: 'dispositivos',
          description: 'Monitore status de bateria e comunicação',
        },
        {
          link: '/reports',
          title: 'relatórios',
          description: 'Gere relatórios de equipamentos',
        },
        {
          link: '/charts',
          title: 'gráficos',
          description: 'Gere gráficos de equipamentos',
        },
        {
          link: '/map',
          title: 'mapa',
          description: 'Monitore equipamentos georreferenciados',
        },
        // {
        //   link: '/weather',
        //   title: 'clima',
        //   description: 'Previsão do clima-tempo',
        // },
        {
          link: '/station',
          title: 'estação',
          description: 'Monitore EMR local, calcule ET0',
        },
        {
          link: '/farms',
          title: 'fazendas',
          description: 'Monitore status de fazendas',
          development: true,
        },
        {
          link: '/sector',
          title: 'setor',
          description: 'Monitore status de setor',
        },
        {
          link: '/alerts',
          title: 'alertas',
          description: 'Monitore alertas enviados',
        }
      ].filter(monit => {
        const isDev = isDevelopment();

        return isDev ? true : !monit.development;
      })
    }
  },
  methods: {
    redirectToMap(title) {
      if (title == 'mapa') window.open('/map-view', '_blank');
    },
  }
}
</script>

<style scoped>
.dashboard-item .btn {
  transition: all 0s;
}
.dashboard-item .btn:hover {
  filter: brightness(92%);
}
.card-details-container {
  padding: 0px 10px;
}
.title-info-card {
  font-weight: 600;
  padding: 0;
  margin: 0;
}

.dashboard-card-bg-premium .icons {
  color: rgb(94, 94, 94);
}

.dashboard-card-bg .icons {
  color: var(--green-3v3);
}
.dashboard-card-bg .title {
  font-weight: 600;
  font-size: 1.3em;
  color: #3d9161;
}
.dashboard-card-bg-premium .title {
  font-weight: 600;
  font-size: 1.3em;
  color: var(--text-secondary-color-black);
}
.card-details {
  color: var(--text-gray-primary);
  font-size: 0.78em;
}
.card-description {
  color: var(--text-gray-primary);
  font-size: 0.75em;
  padding-top: 5px;
  hyphens: auto;
}
hr {
  margin: 8px 0px;
}
@media screen and (max-width: 1100px) and (min-width: 767px) {
  .card-description {
    font-size: 0.8em;
  }
  .title {
    font-size: 1.1em;
  }
}
@media screen and (max-width: 767px) {
  .title {
    font-size: 1.1em;
    margin-bottom: 4px;
  }
  .card-description {
    font-size: 0.75em;
  }
  .dashboard-card .card-info {
    line-height: 0.8em;
  }
  .dashboard .material-design-icon {
    font-size: 3em;
  }
  .dashboard footer a .material-design-icon {
    font-size: 1.2em;
  }
  .card-details-container {
    font-size: 0.85em;
  }
  .dashboard {
    padding-top: 20px;
    padding-bottom: 0px;
  }
}
</style>
</style>
